module.exports = "/static/assets/dce89655ade5b48de30bfd6d39e5aefc.png";